import React from "react";
import "./InfoField.css";
import { format, isValid } from "date-fns";
import { ro } from "date-fns/locale";
import type { StandardFieldProps } from "../types";

const InfoField: React.FC<StandardFieldProps> = (props) => {
  let value = props.value;
  if (props.dataType === "date" && props.dateValue) {
    // Convert dateValue to Date object if it's a string
    let dateToFormat: Date;
    if (props.dateValue instanceof Date) {
      dateToFormat = props.dateValue;
    } else if (typeof props.dateValue === "string") {
      dateToFormat = new Date(props.dateValue);
    } else {
      dateToFormat = props.dateValue as Date;
    }

    // Only format if we have a valid date
    if (dateToFormat && isValid(dateToFormat)) {
      const formatString = props.format || "dd-MM-yyyy";
      const formattedDate = format(dateToFormat, formatString, { locale: ro });

      // Capitalize the first letter of the month name
      value = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    }
  }
  return (
    <div className="main-container mb-2">
      <label>{props.placeholder}:&nbsp;</label>
      <label className={"field-value"}>{value}</label>
    </div>
  );
};

export default InfoField;
